module.exports = __webpack_public_path__ + "static/media/user-check.7e018884.svg";